import { render, staticRenderFns } from "./tmc-map-operations.vue?vue&type=template&id=4b852ecc&scoped=true"
import script from "./tmc-map-operations.vue?vue&type=script&lang=js"
export * from "./tmc-map-operations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b852ecc",
  null
  
)

export default component.exports